import BaseUtil from "../../util/BaseUtil";
import BusinessConstants from "../../constant/BusinessConstants";

const types = BusinessConstants.EMPLOYEE_ITEM_GROUP_TYPE;

const type = `@@ActionType/UPDATE@${__filename}`;


const infoTypeMap = [
    {
        key: "JOB_TITLE",
        value: "职称",
        groups: ["EMP_JOB_TITLE", "EVL_JOB_TITLE"],
    },
    {
        key: types.DUTY.code,
        value: "职务",
    },
    {
        key: types.RANK.code,
        value: "护理层级",
    },
    {
        key: types.SPEC_QUAL.code,
        value: "专科资质",
    },
    {
        key: types.SKILL.code,
        value: "职业技能",
    },
    {
        key: types.EDU_EXP.code,
        value: "教育经历",
    },
    {
        key: types.WORK_EXP.code,
        value: "工作经历",
    },
    {
        key: types.ADVANCED_FURTHER.code,
        value: "进修",
    },
    {
        key: types.ADVANCED_OUTSTUDY.code,
        value: "外出学习",
    },
    {
        key: types.RESEARCH_PROJECT.code,
        value: "科研项目",
    },
    {
        key: types.RESEARCH_PAPER.code,
        value: "论文",
    },
    {
        key: types.ACADEMIC_POST.code,
        value: "学术任职",
    },
    {
        key: types.CERT_DOCTOR.code,
        value: "医师执业证",
    },
    {
        key: types.CERT_NURSE.code,
        value: "护士执业证",
    },
    {
        key: types.CERT_TEACHER.code,
        value: "教师资格证",
    },
    {
        key: types.CERT_OTHER.code,
        value: "其他类型证书",
    },
];


const initState = {
    groupEnabledFinding: true, // 字段组开启状况
    infoTypeMap,
    selectedInfoType: "JOB_TITLE",
    initializing: true,

    selectedUnitIds: null,
    unitsMap: null,

    filterData: null, // 过滤数据
    filterDisplay: null, // 过滤显示

    keyword: "", // 搜索关键词
    checkedUsers: null, // 选中的用户

    tableLoading: false,
    tableData: null, // 表格数据
    originTableData: null, // 表格原始数据。filter
    originData: null, // 请求过来的初始数据
    hideNullUser: true, // 隐藏无数据人员

    items: [], // 字段
    certNurseItems: [], // 护士执业证字段，编辑用
    groups: [], // 字段组
    itemsKeyBy: [], // 字段keyby code，过滤掉没启用的

    picturesModalVisible: false, // 预览图片
    pictures: [], // 预览图片数据

    editCertModalVisible: false, // 护士证照编辑modal
    editCertModalInitializing: true, // 编辑modal初始化
    editData: null, // 编辑数据
    editLoading: false, // 编辑loading
    certNurseCustomVals: null, // 护士证照自定义值

    editOptionModalVisible: false, // 修改选项modal
    editOptionData: null, // 编辑的选项
    editOptionModalLoading: false, // confirmLoading

    extendCertModalVisible: false, // 延续注册modal
    isGroupExtend: false, // 是否是批量延续注册
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
};
export default viewModel;
